/* eslint-disable */
import { createSlice } from '@reduxjs/toolkit';

import axios from '../../utils/axios';
import { dispatch } from '../index';
import { handleError, handleSuccess } from '../../utils/apiResponseHandler.js';

const initialState = {
    error: null,
    compliance: null,
    loading: false,
    saveComplianceLoading: false,
};

const slice = createSlice({
    name: 'compliance',
    initialState,
    reducers: {
        // HAS ERROR
        hasError(state, action) {
            state.error = action.payload;
        },

        isLoading(state, action) {
            state.loading = action.payload;
        },

        isSaveComplianceLoading(state, action) {
            state.saveComplianceLoading = action.payload;
        },

        setComplianceDataSuccess(state, action) {
            state.compliance = action.payload;
        },

        //create a reducer to update the document
        saveComplianceDataSuccess(state, action) {
            state.compliance = { ...state.compliance, ...action.payload };
        },
    }
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------


export function getSingleCompliance() {
    return async () => {
        try {
            dispatch(slice.actions.isLoading(true));

            const response = await axios.get(`/compliance`);
            dispatch(slice.actions.setComplianceDataSuccess(response.data?.data));
        }
        catch (err) {
            handleError(err, dispatch);
        }
        finally {
            dispatch(slice.actions.isLoading(false));
        }
    }
}


export function saveCompliance({doc_id, data}) {
    return async () => {
        try {
            dispatch(slice.actions.isSaveComplianceLoading(true));

            const response = await axios.put(`/compliance/save?cmp_id=${doc_id}`, data);

            dispatch(slice.actions.saveComplianceDataSuccess(response.data?.data))

            handleSuccess(response, "Compliance saved successfully", dispatch);

            return response.data?.data;
        }
        catch (err) {
            handleError(err, dispatch);
        }
        finally {
            dispatch(slice.actions.isSaveComplianceLoading(false));
        }
    }
}